<style lang="scss" src="./_scss/userInfo.scss"></style>
<template>
    <section class="mod_useinfo">
        <div class="left">
            <Avatar class="avatar" :src="avatar" @click="onLoginClick" :defaultAvatar="'https://vip.image.video.qpic.cn/vupload/20230529/743b7e1685351520890.png'" />
        </div>
        <div class="right">
            <div class="nick_wp">
                <b class="nick">{{nickname}}</b>
                <span class="vip" v-if="is_vip">VIP</span>
            </div>
            <div class="expire" v-if="is_vip">{{$lang[14]}} : {{vip_expire_date}}</div>
        </div>
        <!-- 未登录 -->
        <div class="btn_login" v-if="!is_login">
            <button class="btn" @click="onLoginClick">{{$lang[6]}}</button>
        </div>
    </section>
</template>

<script type="text/ecmascript">
import { mapActions } from 'vuex';

import atom from '@tencent/vft-atom';
import Avatar from '@tencent/vft-ui/src/Avatar/Avatar.vue';
import login from '@tencent/wetv-common/login';

export default {
  data() {
    return {};
  },
  async created() {

  },
  mounted() {
    atom.on('onActionLoginFinish', () => {
      this.$store.dispatch('getUserInfo');
    });
  },
  computed: {
    is_login() {
      return this.$store.state.is_login;
    },
    avatar() {
      return this.$store.state.avatar;
    },
    nickname() {
      return this.$store.state.is_login ? this.$store.state.nickname : this.$lang[2];
    },
    is_vip() {
      return this.$store.state.is_vip;
    },
    vip_expire_date() {
      return this.$store.state.vip_expire_date;
    },
  },
  methods: {
    ...mapActions(['clearUserInfo']),
    async onLoginClick() {
      if (login.isLogin()) {
        this.confirm({
          msg: this.$lang[38] || '是否确定退出登录？',
          confirmText: this.$lang[39] || 'Confirm',
          cancelText: this.$lang[36],
          confirm: () => {
            login.logout();
            this.clearUserInfo();
          },
        });
      } else {
        login.openLogin();
      }
    },
  },
  components: {
    Avatar,
  },
};
</script>
